/*
 * @Description: 跟进管理模块数据字典
 * @Author: mdb
 * @Date: 2022-07-19 10:48:56
 * @LastEditTime: 2022-09-06 18:10:44
 * @LastEditors: mdb
 */

// 计划状态枚举
export const planStatusEnum = [
  { label: '计划拜访', value: 1, color: '#1D4CD2' },
  { label: '已延期', value: 2, color: '#EF8D3C' },
  { label: '已拜访', value: 3, color: '#3FAC46' },
  { label: '已取消', value: 4, color: '#C0C4CD' }
]
// 访客提醒枚举
export const remindTypeEnum = [
  { label: '不提醒', value: 1 },
  { label: '提前1小时提醒', value: 2 },
  { label: '提前1天提醒', value: 3 },
  { label: '其它时间', value: 4 }
]
// 客户阶段枚举
export const customerStageEnum = [
  { label: '销售线索', value: 1 },
  { label: '潜在客户', value: 2 },
  { label: '成交客户', value: 4 }
]

export default { planStatusEnum, remindTypeEnum, customerStageEnum }
